import { Injectable } from '@angular/core';
import {
    FavoriteAicraftData,
    Aircraftwatch,
} from 'src/app/models/flight-watch';
import {
    AircraftAssignModalComponent,
    NewCustomerAircraftDialogData,
} from 'src/app/shared/components/aircraft-assign-modal/aircraft-assign-modal.component';
import { FavoriteStrategy } from './favorite.strategy';
import { MatLegacyDialog as MatDialog } from '@angular/material/legacy-dialog';
import { FlightWatchMapSharedService } from 'src/app/pages/flight-watch/services/flight-watch-map-shared.service';
import { FavoritesService } from 'src/app/services/favorites.service';
import { SharedService } from 'src/app/layouts/shared-service';
import { CallbackComponent } from 'src/app/shared/components/favorite-icon/favorite-icon.component';
import { SnackBarService } from 'src/app/ui-services/snackbar/snackBar.service';

@Injectable({
    providedIn: 'root',
})
export class AicraftFavorite implements FavoriteStrategy {
    private _customers: any[] = [];

    public constructor(
        private newCustomerAircraftDialog: MatDialog,
        private flightWatchMapSharedService: FlightWatchMapSharedService,
        private snackbarService: SnackBarService,
        private favoritesService: FavoritesService,
        private sharedService: SharedService
    ) {}

    set customers(customers: any[]) {
        this._customers = customers;
    }
    
    get getCallBackComponent(): CallbackComponent{
        return CallbackComponent.aircraft;
    }
    public getIsFavoriteDefaultValue(favoriteData: FavoriteAicraftData): boolean {
        return favoriteData?.favoriteAircraft != null; 
    }
    public async toogleFavorite(
        favoriteData: FavoriteAicraftData
    ): Promise<FavoriteAicraftData> {
        return !this.hasCustomer(favoriteData)
            ? await this.openAddCustomerToAicraftDialog(
                  favoriteData
              )
            : await this.toogleAicraftFavorite(favoriteData);
    }
    private hasCustomer(favoriteData: FavoriteAicraftData, customerAircraftId: number = null): boolean {
        return favoriteData.isCustomerManagerAircraft || favoriteData.customerAircraftId > 0;
    }
    private async toogleAicraftFavorite(favoriteData: FavoriteAicraftData, customerAircraftId: number = null): Promise<FavoriteAicraftData>{
        if(favoriteData.isFavorite){
            try{
                var result =  await this.favoritesService.saveAircraftFavorite(this.sharedService.currentUser.fboId, favoriteData?.customerAircraftId ?? customerAircraftId, this.sharedService.currentUser.groupId).toPromise();

                if(result){
                    favoriteData.favoriteAircraft = result;
                }
                else{
                    this.snackbarService.showErrorSnackBar("Error adding aircraft to favorites");
                    favoriteData.favoriteAircraft = null;
                    favoriteData.isFavorite = false;
                }    
            }
            catch(error){ 
                favoriteData.favoriteAircraft = null;
                favoriteData.isFavorite = false;
            }
        }
        else{
            try
            {
                await this.favoritesService.deleteAircraftFavorite(favoriteData.favoriteAircraft.oid, this.sharedService.currentUser.groupId).toPromise();
                favoriteData.favoriteAircraft = null;
            }
            catch(error){
                console.error('Error:', error);
                this.snackbarService.showErrorSnackBar("Error removing aircraft from favorites");
            }
        }

        return favoriteData;
    }
    
    private async openAddCustomerToAicraftDialog(
        favoriteData: FavoriteAicraftData
    ): Promise<FavoriteAicraftData> {
        let dialogRef = this.newCustomerAircraftDialog.open<
            AircraftAssignModalComponent,
            Partial<NewCustomerAircraftDialogData>
        >(AircraftAssignModalComponent, {
            data: {
                customers: this._customers,
                tailNumber: favoriteData.tailNumber,
            },
            panelClass: 'aircraft-assign-modal',
            width: '450px',
        });
        let result = await dialogRef.afterClosed().toPromise();
        if (result) {
            let aircraftWatch: Aircraftwatch = {
                customerInfoByGroupId: result.customerInfoByGroupID,
                tailNumber: favoriteData.tailNumber,
                atcFlightNumber: favoriteData.atcFlightNumber,
                aircraftTypeCode: favoriteData.aircraftTypeCode,
                isAircraftOnGround: false,
                flightDepartment: result.company,
                aircraftMakeModel: result.aircraftType,
                lastQuote: favoriteData.lastQuote,
                currentPricing: favoriteData.currentPricing,
                aircraftICAO: favoriteData.aircraftICAO,
                faaRegisteredOwner: favoriteData.faaRegisteredOwner,
                origin: favoriteData.origin,
                destination: favoriteData.destination,
                isJetNetEnabled: false,
                favoriteAircraft: null, // check this property if can assigned with the folwing values
                customerAircraftId: result.customerAircraftId,
            };
            favoriteData.isFavorite = true;
            favoriteData.isCustomerManagerAircraft = true;
            favoriteData.customerInfoByGroupId = result.customerInfoByGroupID;
            favoriteData.customerAircraftId = result.customerAircraftId;

            favoriteData.aircraftAssignResult = result;
            this.flightWatchMapSharedService.updateCustomerAicraftData(
                aircraftWatch
            );

            favoriteData = await this.toogleAicraftFavorite(favoriteData);
        } else {
            favoriteData.isFavorite = false;
        }
        dialogRef = null;

        return favoriteData;
    }
}
